import {useState} from 'react'
import {getSite} from '../../central/services'
import {ProfileByUserModel} from '../../central/model'

export const useSite = () => {
  const [siteData, setSiteData] = useState<ProfileByUserModel[] | any>([])
  const [isLoading, setIsLoading] = useState(false)

  const getSiteList = async (id: any) => {
    setIsLoading(true)
    try {
      const response = await getSite({isCombo: true, clienteId: id}, 1)
      let data = response.data.data
      const mappedSites = data.map((item) => ({value: item.id, label: item.nombre}))
      setSiteData(mappedSites)
      setIsLoading(false)
    } catch (error) {}
  }

  return {isLoading, siteData, getSiteList, setSiteData}
}
